import styled, { css } from 'styled-components';
import { generateClampFromMax } from '@/utils/styling';
import { ImageContainer } from '@/components/atoms/Image/Image.styled';
import { medias } from '@/utils/sizes';


export const TextExclusiveContent = styled.div.withConfig({
  shouldForwardProp: (prop) => !['aspectRatio'].includes(prop),
})<{
  aspectRatio: string;
}>`
  opacity: 0;
  box-sizing: border-box;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--spacing-component-inner-sm);
  width: 100%;
  aspect-ratio: 1.5;
  top: 0;
  transition: opacity var(--tr-base);
`;

export const ObserverWithOverflow = styled.div`
  position: absolute;
  top: -50vh;
  width: 100%;
  height: calc(100% + 60vh);
  pointer-events: none;
`;

export const Project = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isDoubleColumn'].includes(prop),
})<{
  isDoubleColumn: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;

  ${({ isDoubleColumn }) =>
    isDoubleColumn &&
    css`
      height: calc(100% - var(--text-container-height) - var(--spacing-component-inner-xs));

      ${medias.min.tablet} {
        ${TextContainer} {
          position: absolute;
          bottom: 0;
          transform: translateY(100%);
        }
      }

      ${medias.max.mobile} {
        height: calc(100% - var(--text-container-height) - 15px);
      }

      ${ImageContainer},
      > div {
        height: 100%;
      }
    `}

  iframe {
    pointer-events: none;
  }
`;

export const ProjectsGrid = styled.div`
  --text-container-height: ${generateClampFromMax(80)};

  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-component-inner);

  a:nth-child(3),
  a:nth-child(8) {
    grid-column: span 2;

    ${medias.max.mobile} {
      > div:not(.loader-spinner):not(.loader-spinner-animated) 
        > div:first-child:not(.loader-spinner):not(.loader-spinner-animated) {
        aspect-ratio: 1.6;
        height: 100%;
        width: 100%;
      }

      .video-container,
      .vimeo-video-container,
      ${ImageContainer} {
        aspect-ratio: 1.74 !important
      }
    }
  }

  .loader-spinner-animated {
    border-width: 1px !important;
  }

  a {
    align-items: flex-start;
    overflow: visible;
  }

  .private-project {
    cursor: pointer;

    img {
      transition: filter var(--tr-base);
    }
    &:hover {
      img {
        filter: blur(3px);
      }

      ${TextExclusiveContent} {
        opacity: 1;
      }
    }
  }

  ${medias.max.tablet} {
    --text-container-height: 45px;
  }

  ${medias.max.mobile} {
    --text-container-height: 26px;
    grid-template-columns: repeat(2, 1fr);
    row-gap: clamp(15px, 11vw, 60px);
  }
`;

export const TextContainer = styled.div`
  padding-top: var(--spacing-component-inner-xs);
  height: var(--text-container-height);

  ${medias.max.mobile} {
    padding-top: 15px;
  }
`;
export const TopContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--c-border);
  padding: var(--spacing-component-inner) 0;

  ${medias.max.mobile} {
    box-sizing: border-box;
    min-height: 83px;
  }
`;
